import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Briefing: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 42.39 43.45">
            <g>
                <g>
                    <rect fill={color} x="5.79" y="13.37" width="3.51" height="1.86"/>
                    <rect fill={color} x="12.24" y="13.37" width="15.03" height="1.86"/>
                    <rect fill={color} x="5.79" y="18.87" width="3.51" height="1.86"/>
                    <rect fill={color} x="12.24" y="18.87" width="15.03" height="1.86"/>
                    <rect fill={color} x="5.79" y="24.36" width="3.51" height="1.86"/>
                    <rect fill={color} x="5.79" y="29.86" width="3.51" height="1.86"/>
                    <rect fill={color} x="5.79" y="35.36" width="3.51" height="1.86"/>
                    <rect fill={color} x="12.24" y="35.36" width="15.03" height="1.86"/>
                    <path fill={color} d="M23.89,2.95V0h-14.72v2.95H0v37.98l1.86-1.76V4.81h7.31v3.03h14.72v-3.03h7.3v17.19l1.86-.99V2.95h-9.17ZM22.02,2.95v3.03h-10.99V1.86h10.99v1.08Z"/>
                </g>
                <path fill={color} d="M39.83,17.4l-6.77,3.6-1.86.99-4.45,2.37h-14.5v1.86h11l-3.06,1.63c-.42.22-.79.53-1.09.9l-.9,1.11h-5.95v1.86h4.44l-.29.36-1.03,1.35,1.75.16,4.22-.09c.56-.01,1.12-.16,1.61-.42l2.55-1.37v.02h1.79v-.98l3.92-2.11v12.95H2.02l-1.97,1.86h33.01v-15.82l9.33-5.02-2.56-5.21ZM22.05,31.43c-.24.13-.5.2-.77.2l-2.17.05,1.42-1.75c.14-.18.32-.32.52-.43l6.15-3.27.06-.03,11.73-6.24.92,1.87-17.87,9.61Z"/>
            </g>
        </svg>
    );
};

export default Briefing;
